import React from "react";
import { IOfferParams } from "ui/components/offers/params";
import "./_offer-small.scss"
import ReactCountryFlag from "react-country-flag";
import { getOfferImageUrl, hasOfferImage } from "utils/offer-image";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';

export default (params: IOfferParams) => {
    let { offer, showCountry, onClick } = params

    const hasImage = hasOfferImage(offer);
    let bg = hasImage ? getOfferImageUrl(offer, 'bg') : '';

    return (
        <div className="offer-small" onClick={() => onClick(offer)}>
            <div className="offer-small-thumbnail noselect">
                {hasImage ? (
                    <img className="offer-small-thumbnail-bg" src={bg} />
                ) : (
                    <div className="offer-small-thumbnail-placeholder">
                        <FontAwesomeIcon icon={faImage} />
                    </div>
                )}
            </div>
            {showCountry && (
                <ReactCountryFlag 
                    style={{
                        fontSize: '1.2rem',
                        lineHeight: '1.2rem',
                        flexShrink: 0,
                        marginLeft: '8px'
                    }} 
                    className="offer-country-sign noselect" 
                    countryCode={offer.geo} 
                />
            )}
            <div className="offer-small-center noselect">
                <span className="offer-small-center-title">{offer.caption}</span>
                <span className="offer-small-center-subtitle">{(offer as any).generatedKey || offer.name}</span>
            </div>
            <div className="offer-small-end">
                {showCountry && (
                    <span className="offer-country noselect">{offer.geo}</span>
                )}
                <div className="offer-end-space" />
                <span className="offer-id noselect">#{offer.id}</span>
            </div>
        </div>
    )
};
